import { useEffect, useMemo } from 'react';
import { getName, registerLocale, getAlpha2Codes } from 'i18n-iso-countries';
import english from 'i18n-iso-countries/langs/en.json';

import { useCurrentLocale } from 'utils/hooks/useTranslation';

import { doesPhoneCountryMatchSearch } from './doesPhoneCountryMatchSearch';

type UsePhoneCountryOptionsProps = {
  search: string;
};

export const usePhoneCountryOptions = ({ search }: UsePhoneCountryOptionsProps) => {
  const { language } = useCurrentLocale();
  useEffect(() => registerLocale(english), []);

  return useMemo(
    () =>
      Object.keys(getAlpha2Codes())
        .map((countryCode) => ({
          title: getName(countryCode, language, { select: 'official' }) ?? countryCode,
          subtitle: countryCode,
          value: countryCode.toString(),
        }))
        .filter((option) => doesPhoneCountryMatchSearch(option.title, option.subtitle, search))
        .sort(({ title: a }, { title: b }) => a.localeCompare(b)),
    [search, language],
  );
};
